import './Regulators.css';
import Navbar from './Navbar.js';
import brain2 from './regulator-2.jpg';
import Footer from './footer.js';
import PDF from './pdf.js';
import video_brain2 from './2.mp4';
import React, { useRef } from 'react';
import VideoPlayer from "./Video_Player.js";

  

const Regulators = () => {
  const videoRef = useRef(null);
  const lastTime = useRef(0);

  const handleTimeUpdate = () => {
    const video = videoRef.current;
    if (!video) return;
    if (Math.abs(video.currentTime - lastTime.current) > 1) {
      video.currentTime = lastTime.current;
    } else {
      lastTime.current = video.currentTime;
    }
  };
  return (
    <div className="Regulators-page">
       <Navbar />
      <main className="Regulators-hero">
        <h1>Cnyda Dynamics Product Division</h1>
        <div className="Regulators-content">
          <h1>Quantifying Risk of Insider Trading :</h1>
          <p>
            We have developed a groundbreaking Cognitive Brain AI architecture specifically designed for stock market regulators worldwide.
            This innovative solution is geared towards monitoring, detecting, and gathering scientific evidence on nefarious activities such as insider trading,
            pump-and-dump schemes, and other forms of market manipulation.This innovative product is poised to revolutionize the detection of insider trading and other fraudulent activities, 
            empowering regulatory authorities with a powerful tool in their ongoing efforts to combat market manipulation and protect investors. 
            We are engaging with regulatory authorities and are prepared to showcase our cutting-edge technology through a live demonstration.
          </p>
          <video 
            src={video_brain2} 
            className="image_Regulators" 
            autoPlay 
            loop 
            muted 
            playsInline
          />
        </div>
        <div className="video-content-wrapper_em">
        <div className="video-header">
            <h1>Video White Paper</h1>
        </div>
           <VideoPlayer src="/summery_video.mp4" />
          <div className="pdf-paper">
          <h1>Read Full White Paper</h1>
          </div>
          <PDF 
          title="White Paper" 
          file="/SEBI_paper_v3_new.pdf"
        />
        </div>
      </main> 
      <Footer/>
    </div>
  );
};

export default Regulators;